export const IconCallOut = ({ className = null, width = '1em', height = '1em', ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9 1a1 1 0 00-2 0v1a1 1 0 002 0V1zm4.657 2.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM16 8a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM3.05 4.464A1 1 0 104.464 3.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM3 8a1 1 0 01-1 1H1a1 1 0 010-2h1a1 1 0 011 1zm3 6v-1h4v1a2 2 0 01-4 0zm4-2c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002H10z"
        fill="#121826"
      />
    </svg>
  );
};
